<div fxFlex fxLayout="column">
    <!-- Header -->
    <div class="header">
        <h2 i18n="Switch organization|Header">Switch Organization</h2>
        <p *ngIf="isSysAdmin" i18n="Switch organization|Description">
            Choose an organization and adjust permissions as necessary.
        </p>
    </div>

    <!-- Spinner -->
    <mat-spinner style="margin: 0 auto" *ngIf="loading" [diameter]="90"></mat-spinner>

    <!-- Content -->
    <div class="content" fxLayout="column" *ngIf="!loading">
        <ng-container *ngIf="isSysAdmin; then sysAdminTemplate; else userTenancyAccessTemplate"></ng-container>
    </div>

    <!-- Footer -->
    <div class="footer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <div fxFlex></div>
        <button mat-raised-button color="primary" (click)="cancel()" (keydown.enter)="cancel()">
            <span translate>common.buttons.cancel</span>
        </button>
        <button
            mat-raised-button
            [disabled]="loading || !selectedTenant"
            color="accent"
            (click)="ok()"
            (keydown.enter)="ok()"
        >
            OK
        </button>
    </div>
</div>

<!-- Impersonate to another organization with role selection (sysAdmin view) -->
<ng-template #sysAdminTemplate>
    <!-- Select organization -->
    <ce-search-with-autocomplete
        placeholder="Organization *"
        [options$]="autocompleteTenants$"
        (optionSelected)="selectTenant($event)"
        (optionConfirmed)="ok()"
        [focusInputOnLoad]="true"
    ></ce-search-with-autocomplete>

    <!-- Select roles -->
    <ng-container *ngIf="defaultRole; else customRoleTemplate">
        <!-- default role -->
        <p translate>
            common.dialogs.impersonate.login_with_default_privileges
            <span class="link" (click)="useCustomRole()" (keydown.enter)="useCustomRole()" translate
                >common.buttons.change</span
            >
        </p>
    </ng-container>

    <!-- custom role -->
    <ng-template #customRoleTemplate>
        <div fxLayout="column" fxLayoutGap="20px">
            <p translate>common.dialogs.impersonate.login_with_special_privileges</p>
            <!-- system roles -->
            <div fxLayout="row">
                <mat-form-field fxFlex floatLabel="auto">
                    <!-- system roles in practice, just named as privileges -->
                    <mat-label translate>common.dialogs.impersonate.privileges</mat-label>
                    <mat-select id="roles" [(value)]="selectedSystemRole">
                        <mat-option *ngFor="let sr of systemRolesToImpersonate" [value]="sr.id">
                            {{ sr.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- tenant roles -->
            <ce-multiselect-autocomplete
                *ngIf="((tenantRoles$ | async) || [])?.length"
                [label]="'Roles created by tenant'"
                [items]="(tenantRoles$ | async) || []"
                [customerPrivacyFilter]="'randomNumber'"
                (selectedChanged)="selectedTenantRolesChanged($event)"
            ></ce-multiselect-autocomplete>
        </div>
    </ng-template>
</ng-template>

<!-- Impersonate to another organization with tenancy access -->
<ng-template #userTenancyAccessTemplate>
    <div *ngIf="!isSysAdmin" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="12px">
        <mat-label translate>common.dialogs.impersonate.select_organization</mat-label>
        <mat-select [(value)]="selectedTenancyAccess" (selectionChange)="changeSelectedUserTenancyAccess($event)">
            <mat-option *ngFor="let sr of userTenancies" [value]="sr">
                {{ sr.targetTenantName }}
            </mat-option>
        </mat-select>

        <ng-container *ngIf="selectedTenancyAccess && selectedTenancyAccessPrivileges">
            <p translate>common.dialogs.impersonate.following_permissions_has_been_granted</p>
            <strong>{{ selectedTenancyAccessPrivileges }}</strong>
        </ng-container>
    </div>
</ng-template>
